import { render } from "./ContentArticle.vue?vue&type=template&id=03fa473a&scoped=true"
import script from "./ContentArticle.vue?vue&type=script&lang=js"
export * from "./ContentArticle.vue?vue&type=script&lang=js"

import "./ContentArticle.vue?vue&type=style&index=0&id=03fa473a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jekr\\Documents\\arla-foods-sc-event-platform\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03fa473a"]])

export default __exports__